import type { Product } from '@commerce/types/product'
import { Button } from '@components/ui'
import { findMetafieldValueByKey } from '@lib/helpers/general'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

const ViewColours = ({
  product,
  isLandingPageProduct,
}: {
  product: Product
  isLandingPageProduct: boolean
}) => {
  const { push } = useRouter()
  const { t } = useTranslation(['common'])
  const handleViewColours = () => {
    const landingPageLink = findMetafieldValueByKey(
      product.metafields!,
      'landing_page_link'
    )
    push(landingPageLink || '/collection/colour-lab')
  }

  if (!isLandingPageProduct) return null
  return (
    <div className="flex gap-3 pt-10 lg:mt-auto lg:pt-0">
      <Button
        aria-label={`${t('view-colours')}`}
        type="button"
        width="100%"
        onClick={handleViewColours}
      >
        {t('view-colours')}
      </Button>
    </div>
  )
}

export default ViewColours
